import { Store } from './store'
import { Address } from './geo'

export interface Preference {
  storeId?: number
}

export enum CustomerAddressType {
  Default = 'Default',
  Delivery = 'Delivery',
  Invoice = 'Invoice',
}

export interface CustomerAddress extends Address {
  id?: number
  customerId?: number
  type?: string
  name?: string
  addressType?: string
  firstName?: string
  lastName?: string
  middleName?: string
  companyName?: string
  gender?: string
  phoneNumber?: string
  emailAddress?: string
  memo?: string
  externalId?: string
}

export interface Customer {
  id: number
  email: string
  firstName?: string
  lastName?: string
  middleName?: string
  defaultStoreId?: number
  defaultStore?: Store
  gender?: string
  mobileNumber?: string
  phoneNumber?: string
  dateOfBirth?: string
  isOptIn?: boolean
  addresses?: CustomerAddress[]

  allowOnAccount?: boolean
  contactId?: number
  contactAddress?: CustomerAddress
  bonusPoints?: number
  creditLimit?: number
  creditBalance?: number
  groupCode?: string
  kvkNumber?: string
  companyName?: string
  languageCode?: string
  totalBonusPoints?: number
  priceListId?: number
}

export interface AccountItem {
  cacheDate: number // timestamp
  value: any
  label: string
}

export interface CustomerAccount {
  orderCount?: AccountItem
  wishlistCount?: AccountItem
}

export interface ChangePasswordParams {
  currentPassword: string
  newPassword: string
}
